/* OneUp Cleaning: live product prices inside blog articles.
   Markup (the static text inside each span is the fallback crawlers and no-JS readers see):
     <span data-lp-price="handle">$3,599</span>                       starting price of one product
     <span data-lp-from="handle">From $14,500</span>                  "From $X" when kits vary, "$X" when not
     <span data-lp-range="h1,h2,h3">$1,921 to $4,995</span>           lowest to highest starting price
     <span data-lp-range="all" data-lp-format="approx">about $1,900 to $34,000</span>
     <span data-lp-diff="handle|Dual Battery">$580</span>             kit price minus starting price
     <span data-lp-note>Prices as of September 16, 2026.</span>
   Handles are the part after /products/ in the URL, exactly as it appears (percent-encoding included). */
(function () {
  var SEL = '[data-lp-price],[data-lp-from],[data-lp-range],[data-lp-diff]';
  var CACHE_KEY = 'oneup-lp:', CACHE_MS = 30 * 60 * 1000;

  function fmt(cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function approx(minC, maxC) {
    var lo = Math.floor(minC / 100 / 100) * 100, hi = Math.round(maxC / 100 / 1000) * 1000;
    return 'about $' + lo.toLocaleString('en-US') + ' to $' + hi.toLocaleString('en-US');
  }
  function range(minC, maxC) { return minC === maxC ? fmt(minC) : fmt(minC) + ' to ' + fmt(maxC); }

  function getProduct(handle) {
    try {
      var hit = JSON.parse(sessionStorage.getItem(CACHE_KEY + handle) || 'null');
      if (hit && Date.now() - hit.t < CACHE_MS) return Promise.resolve(hit.p);
    } catch (e) {}
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var p = { min: j.price_min, varies: j.price_varies,
                  variants: (j.variants || []).map(function (v) { return { title: v.title, price: v.price }; }) };
        try { sessionStorage.setItem(CACHE_KEY + handle, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
        return p;
      });
  }

  function run(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll(SEL));
    if (!els.length) return;
    var handles = {}, rangeHandles = [];
    els.forEach(function (el) {
      var list = [];
      if (el.dataset.lpPrice) list = [el.dataset.lpPrice];
      if (el.dataset.lpFrom) list = [el.dataset.lpFrom];
      if (el.dataset.lpDiff) list = [el.dataset.lpDiff.split('|')[0]];
      if (el.dataset.lpRange && el.dataset.lpRange !== 'all') { list = el.dataset.lpRange.split(','); rangeHandles = rangeHandles.concat(list); }
      if (el.dataset.lpFrom) rangeHandles.push(el.dataset.lpFrom);
      list.forEach(function (h) { handles[h.trim()] = true; });
    });
    var keys = Object.keys(handles), data = {};
    Promise.all(keys.map(function (h) {
      return getProduct(h).then(function (p) { data[h] = p; }, function () { data[h] = null; });
    })).then(function () {
      var ok = 0;
      els.forEach(function (el) {
        var d = el.dataset, text = null;
        if (d.lpPrice && data[d.lpPrice]) text = fmt(data[d.lpPrice].min);
        if (d.lpFrom && data[d.lpFrom]) text = (data[d.lpFrom].varies ? 'From ' : '') + fmt(data[d.lpFrom].min);
        if (d.lpDiff) {
          var parts = d.lpDiff.split('|'), p = data[parts[0]];
          var v = p && p.variants.filter(function (x) { return x.title.indexOf(parts[1]) !== -1; })[0];
          if (v) text = fmt(v.price - p.min);
        }
        if (d.lpRange) {
          var hs = d.lpRange === 'all' ? rangeHandles : d.lpRange.split(',');
          var mins = hs.map(function (h) { return data[h.trim()] ? data[h.trim()].min : null; });
          if (mins.indexOf(null) === -1 && mins.length) {   // never show a partial range
            var lo = Math.min.apply(null, mins), hi = Math.max.apply(null, mins);
            text = d.lpFormat === 'approx' ? approx(lo, hi) : range(lo, hi);
          }
        }
        if (text !== null) { el.textContent = text; ok++; }
      });
      if (ok === els.length) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-lp-note]'), function (n) {
          n.textContent = 'Prices update live from our store.';
        });
      }
    });
  }

  function start() {
    var first = document.querySelector(SEL);
    if (!first) return;
    if (!('IntersectionObserver' in window)) return run(document);
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); run(document); }
    }, { rootMargin: '800px 0px' });
    io.observe(first);
  }
  if (typeof module !== 'undefined') { module.exports = { fmt: fmt, approx: approx, range: range }; return; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
